export const Abstract05Icon = () => {
  return (
    <svg
      width="125"
      height="126"
      viewBox="0 0 125 126"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5582 125.75C10.1442 125.75 0.891602 116.497 0.891602 105.083V21.4691C0.891602 10.0551 10.1442 0.802116 21.5582 0.802116C32.9722 0.802116 42.2248 10.0551 42.2248 21.4691V105.083C42.2248 116.497 32.9722 125.75 21.5582 125.75Z"
        fill="url(#paint0_linear_1866_18445)"
      />
      <path
        d="M62.8922 125.75C51.4782 125.75 42.2256 116.497 42.2256 105.083V21.4691C42.2256 10.0551 51.4782 0.802116 62.8922 0.802116C74.3058 0.802116 83.5588 10.0551 83.5588 21.4691V105.083C83.5588 116.497 74.3058 125.75 62.8922 125.75Z"
        fill="url(#paint1_linear_1866_18445)"
      />
      <path
        d="M104.225 125.75C92.8116 125.75 83.5586 116.497 83.5586 105.083V21.4691C83.5586 10.0551 92.8116 0.802116 104.225 0.802116C115.639 0.802116 124.892 10.0551 124.892 21.4691V105.083C124.892 116.497 115.639 125.75 104.225 125.75Z"
        fill="url(#paint2_linear_1866_18445)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1866_18445"
          x1="21.5582"
          y1="0.802109"
          x2="21.5582"
          y2="125.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0.08" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1866_18445"
          x1="62.8922"
          y1="0.802109"
          x2="62.8922"
          y2="125.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0.08" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1866_18445"
          x1="104.225"
          y1="0.802109"
          x2="104.225"
          y2="125.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0.08" />
        </linearGradient>
      </defs>
    </svg>
  );
};
